<script setup lang="ts">
    import NavbarInd from '@/pages/components/Generales/NavbarInd.vue';
    // import { defineAsyncComponent, ref } from 'vue';
    // const PersonaHumanitas = defineAsyncComponent(() => import('../components/PersonaHumanitas.vue')) ; 
    // const CarruCasosExito = defineAsyncComponent(() => import('../components/oferta/CasosExitoPrime.vue')); 
    // const InfoTresImagenes = defineAsyncComponent(() => import('../components/InfoTresImagenes.vue'));

    // const images = ref([
    //     {
    //         src: '/pagesImages/ejecutivo-BLANCO.webp',
    //         link: 'https://humanitas.edu.mx/ejecutivo',
    //         nombre: 'EJECUTIVO',
    //         alt: 'Modelo Ejecutivo',
    //         describ: 'Modo semi-presencial. Sólo asistes una vez a la semana al Campus.',
    //     },
    //     {
    //         src: '/pagesImages/escolarizado-BLANCO.webp',
    //         link: 'https://humanitas.edu.mx/escolarizado',
    //         nombre: 'ESCOLARIZADO',
    //         alt: 'Modelo Escolarizado',
    //         describ: 'Jóvenes entre 17 y 21 que buscan superarse mediante un modelo presencial.',
    //     },
    //     {
    //         src: '/pagesImages/virtual-BLANCO.webp',
    //         link: 'https://virtual.humanitas.edu.mx/',
    //         nombre: 'VIRTUAL',
    //         alt: 'Modelo Virtual',
    //         describ: 'Pensando en profesionales que mantienen un ritmo de vida muy ocupado.',
    //     },
    // ]);
</script>

<template>
    <NavbarInd />
    <section class="flex flex-col justify-center items-center w-full">
        <!-- <div class="flex pt-[88px] lg:pt-[143px] justify-center items-center mb-12 w-screen flex-col">
            <div class="flex items-center justify-center w-full bg-center md:h-[500px] bg-cover md:bg-[center-right] bg-no-repeat" style="background-image: url(/pagesImages/requisitos-bnr-nv2.jpg);">
                <div class="flex justify-center w-full">
                    <div class="flex text-justify w-full justify-center items-center max-w-4xl lg:max-w-[1200px] bg-white/50 md:bg-transparent">
                        <div class="w-full items-end flex md:my-12 my-8  flex-col px-4">
                            <h1 class="font-normal mb-0 text-[30px] text-hwine">Requisitios de</h1>
                            <h1 class="font-serif text-hwine text-[50px] mb-2">Inscripci&oacute;n</h1>
                            <p class="text-hwine font-serif text-[32px]">Maestr&iacute;a</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="flex pt-[88px] lg:pt-[143px] justify-center items-center w-screen flex-col mb-16">
            <div class="flex items-center justify-center w-full bg-center md:h-[500px] bg-cover md:bg-[center] bg-no-repeat" style="background-image: url(/pagesImages/ecabezado-requisitos-estatuas.webp);">
                <div class="flex justify-center bg-white/20 h-full w-full">
                    <div class="flex text-justify w-full justify-center items-center max-w-4xl lg:max-w-[1200px] bg-white/50 md:bg-transparent">
                        <div class="w-full items-end flex md:mb-[16%] my-8  flex-col px-4">
                            <h1>    
                                <span class="block font-normal mb-0 text-[30px] text-hwine">Requisitos de</span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span>
                                <span class="block font-serif text-hwine text-[50px] mb-2">Inscripci&oacute;n</span>
                                <span class="sr-only whitespace-nowrap">&nbsp; para las</span>
                                <span class="block text-hwine font-serif text-[32px]">Maestr&iacute;as</span>
                                <span class="sr-only whitespace-nowrap">&nbsp; de Universidad Humanitas</span>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="flex items-center justify-center mb-16 w-full">
            <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                <div class="flex flex-col justify-between">
                    <div class="lg:flex items-center justify-center">
                        <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                            <img src="/pagesImages/requisitos-mexico.webp" alt="alt pendiente" class="w-full lg:max-w-[520px]"/>
                        </div>
                        <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                            <h2>
                                <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                <span class="block text-hgold text-left font-serif mb-3 text-[32px]">Alumnos con estudios en México</span>
                            </h2>
                            <p class="mb-4">
                                Para el modelo Ejecutivo se requiere de una entrevista.
                            </p>
                            <ul class=" list-disc pl-8 mb-4">
                                <li>Presentar título de Licenciatura.</li>
                                <li>Cédula de Licenciatura.</li>
                                <li>Credencial INE.</li>
                                <li>Contar con Clave Única de Registro de Población (CURP) actualizada.</li>
                            </ul>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
        <section class="flex items-center justify-center mb-16 w-full">
            <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                <div class="flex flex-col justify-between">
                    <div class="lg:flex items-center justify-center">
                        <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                            <h2>
                                <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                <span class="block text-hgold text-left font-serif mb-3 text-[32px]">Alumnos en otros países</span>
                            </h2>
                            <ul class=" list-disc pl-8 mb-4">
                                <li>Registro civil de nacimiento.</li>
                                <li>Documento de identidad o pasaporte vigente.</li>
                                <li>Diploma de título Profesional.</li>
                                <li>Acta de Grado de Título Profesional.</li>
                                <li>Recibo de Servicio Público del Domicilio.</li>
                                <li>Hoja de Vida.</li>
                                <li>Carta de Exposición de Motivos.</li>
                            </ul>
                            <p class="">
                                En caso de equivalencia de estudios, el aspirante deberá presentar, además de los requisitos anteriores, certificado parcial de estudios expedido por la institución educativa de procedencia, con reconocimiento de validez oficial.
                            </p>
                        </div>
                        <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                            <img src="/pagesImages/requisitos-otros-paises.webp" alt="alt pendiente" class="w-full lg:max-w-[520px]"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="flex items-center justify-center mb-16 w-full">
            <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                <div class="flex flex-col justify-between">
                    <div class="lg:flex items-center justify-center">
                        <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                            <img src="/pagesImages/requisitos-banderas.webp" alt="alt pendiente" class="w-full lg:max-w-[520px]"/>
                        </div>
                        <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                            <h2>
                                <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                <span class="block text-hgold text-left font-serif mb-3 text-[32px]">Alumnos con estudios en el extranjero</span>
                            </h2>
                            <p class="mb-4">
                                La institución admitirá alumnos provenientes del extranjero en el nivel de Maestría, toda vez que cumplan con los siguientes requisitos:
                            </p>
                            <ul class=" list-disc pl-8 mb-4">
                                <li>Entregar revalidación de estudios realizados fuera del país, emitido por la Secretaría de Educación Pública (SEP).</li>
                                <li>Tener certificado de nacimiento y estudios, legalizados por el país de origen.</li>
                            </ul>
                            <p class="italic">
                                *La Institución se reserva el derecho de admisión en cualquiera de los programas de estudio.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="flex items-center border border-gray w-screen justify-center bg-cover bg-[top_left] bg-no-repeat mb-12" style="background-image: url(/pagesImages/bgs-diseno.jpg);">
            <div class="flex items-center my-24 justify-center">
                <div class="lg:flex items-center justify-between px-4">
                    <div class="flex mx-auto mr-28 text-left flex-col mb-4">
                        <h2>
                            <span class="block text-hwine leading-none text-[32px] font-normal">Requisitos de</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hwine text-[52px] font-serif">Titulación</span>
                        </h2>
                    </div>
                    <div class="flex mx-auto text-[black] text-justify flex-col text-sm">
                        <h2 class="text-lg text-left uppercase">Requisitos y documentación para titulación</h2>
                        <ul class="pl-8 list-[disc]">
                            <li>Certificado Total de Maestr&iacute;a.</li>
                            <li>Contar con Clave Única de Registro de Población (CURP) actualizada.</li>
                            <li>Haber cubierto la totalidad de pagos de colegiaturas y costo de trámite.</li>
                        </ul>
                        <br>
                        <br>
                        <h2 class="text-lg text-left uppercase">Opciones de titulación de Maestría en Humanitas</h2>
                        <br>
                        <h3 class="text-black font-semibold">SEMINARIO DE CASOS:</h3>
                        <p>Cursar y acreditar el Seminario.</p>
                        <br>
                        <h3 class="text-black font-semibold">TESIS:</h3>
                        <p>Cumplir con los requisitos de la Tesis.</p>
                        <p class="text-xs">(Consultarlos en la Direcci&oacute;n o Coordinaci&oacute;n Acad&eacute;mica).</p>
                        <p>Solicitar tr&aacute;mite de certificado parcial al momento de cubrir los cr&eacute;ditos requeridos.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="flex flex-col justify-center w-full max-w-4xl lg:max-w-[1200px] tracking-tighter mb-16">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-x-8 lg:gap-y-20 ">
                <div class="flex flex-col w-full text-justify items-center px-4">
                    <div class="flex flex-col w-full text-justify items-center mb-5">
                        <h2 class="text-hgold left-0 text-center leading-tight font-serif md:text-[28px] text-[24px] md:w-[450px] mb-4">¿Qué opciones de financiamiento tienen los estudiantes en Universidad Humanitas?</h2>
                        <p class="text-base ">A fin de apoyar la economía de los estudiantes de Universidad Humanitas y en alianza estratégica con FUERZA H A.C., ha establecido un fondo de inversión social para fortalecer su misión y ampliar su impacto. Este fondo busca generar oportunidades sostenibles que impulsen el desarrollo integral.</p>
                    </div>
                    <div class="flex items-center justify-center">
                        <router-link to="/contacto">
                            <button class="rounded-none hover:bg-hwine bg-hgold text-white transition duration-300 ease-in-out text-xl ">
                                Contáctanos
                            </button>
                        </router-link>
                    </div>
                </div>
                <div class="flex flex-col justify-center items-center">
                    <img src="/pagesImages/financiamiento-programas-humanitas.webp" alt="" class="px-4 w-full h-full max-h-[520px] max-w-[520px]">
                </div>
            </div>
        </div> -->

        <!-- <div class="lg:flex items-center gap-8 justify-center lg:mb-12 w-full max-w-4xl lg:max-w-[1200px]">
            <div v-for="(image, index) in images" :key="index" class="flex items-center justify-center lg:m-0 m-4 max-w-4xl  lg:max-w-[1200px]">
                <InfoTresImagenes :img="image.src" :titulo="image.nombre" :alt="image.alt" :enlace="image.link" :descrip="image.describ"  />
            </div>
        </div>

        <PersonaHumanitas />

        <CarruCasosExito /> -->
    </section>
</template>

<style scoped>
</style>